// Navigation index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    isOpen: false,
    isLeftOpen: false,
    activeLeftMenuItem: '',
    activeMenuItem: '',
    links: [
      // 1st group - shortcuts
      {
        panels: [
          {
            title: 'My shortcuts',
            icon: {
              name: 'star',
              size: 20,
            },
            links: [
              {
                title: 'Booking history',
                link: '/shipments/outbound',
                description: 'View your shipments',
                icon: 'listBullet',
                permission: 'shipment/history',
              },
              {
                title: 'Book shipment',
                link: '/shipments/book-shipment',
                description: 'Create a shipment in minutes',
                icon: 'airplane',
                permission: 'shipment/book-shipment',
              },
            ],
          },
        ],
      },
      // 2nd group - main menu
      {
        panels: [
          // Level 1 panel
          {
            title: 'Your Choices',
            level: 1,
            icon: {
              name: 'menu',
              size: 20,
            },
            links: [
              {
                title: 'Dashboard',
                link: '/',
                description: 'Your daily overview',
                icon: 'dashboard',
                permission: 'dashboard',
              },
              {
                title: 'Shipments',
                link: '/shipments',
                description: 'Manage your shipments',
                icon: 'truck',
                submenu: 'shipments',
                permission: true,
              },
              {
                title: 'item_catalog',
                link: '/items',
                description: 'item_catalog_subtext',
                icon: 'softBag',
                permission: 'items/items',
              },
              {
                title: 'address_book',
                link: '/contacts',
                description: 'All your customers profiles',
                icon: 'contacts',
                permission: 'customer/customer',
              },
              {
                title: 'Settings',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'settings',
                permission: true,
              },
              {
                title: 'Reports',
                link: '/reports',
                description: 'Get data with reports',
                icon: 'cloudDownload',
                permission: 'report/report',
              },
              {
                title: 'Finance',
                link: '/finance',
                description: 'Your finances',
                icon: 'coins',
                permission: 'finance/invoices',
              },
            ]
          },
          // Level 2 panel(s)
          {
            submenu: 'shipments',
            level: 2,
            title: 'Shipments',
            icon: null,
            links: [
              {
                title: 'Book shipment',
                link: '/shipments/book-shipment',
                description: 'Compare and book',
                icon: 'calendar',
                permission: 'shipment/book-shipment',
              },
              {
                title: 'Waiting for approval',
                link: '/shipments/unapproved-shipments',
                description: 'View all unapproved',
                icon: 'checkAll',
                permission: 'shipment/unapproved-shipments',
              },
              {
                title: 'drafts',
                link: '/shipments/drafts',
                description: 'Uploaded, failed etc.',
                icon: 'edit',
                permission: 'shipment/draft',
              },
              {
                title: 'outbound_shipments',
                link: '/shipments/outbound',
                description: 'View your shipments',
                icon: 'shipmentsAll',
                permission: 'shipment/history',
              },
              {
                title: 'End of Day',
                link: '/shipments/end-of-day',
                description: 'View all your manifest',
                icon: 'endOfDay',
                permission: 'shipment/end-of-day',
              },
              {
                title: 'Consolidations',
                link: '/shipments/consolidations',
                description: 'View all your consolidations',
                icon: 'pallet',
                permission: 'shipment/consolidations',
              },
            ],
          },
          {
            submenu: 'settings',
            level: 2,
            title: 'Settings',
            icon: null,
            links: [
              {
                title: 'platform',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'systemSettings',
                permission: true,
              },
              {
                title: 'Shipping',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'shipmentSettings',
                permission: true,
              },
              {
                title: 'Integration',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'integrationSettings',
                permission: true,
              },
            ],
          },
          {
            submenu: 'finances',
            level: 2,
            title: 'Finances',
            icon: null,
            links: [
              {
                title: 'Invoices',
                link: '/invoices',
                description: 'See your invoices',
                icon: 'document',
                permission: 'finance/invoices',
              },
            ],
          },
          // Level 3 panel(s)
          {
            submenu: 'systemSettings',
            level: 3,
            title: 'platform',
            icon: null,
            links: [
              {
                title: 'Printers',
                link: '/settings/platform/printers',
                description: 'Your printers',
                icon: 'printer',
                permission: 'settings/printer',
              },
              {
                title: 'Team',
                link: '/settings/platform/team',
                description: 'Your team',
                icon: 'team',
                permission: 'settings/team',
              },
              {
                title: 'SMTP',
                link: '/settings/platform/smtp',
                description: 'Your smtp',
                icon: 'server',
                permission: 'settings/smtp',
              },
              {
                title: 'system',
                link: '/settings/platform/system',
                description: 'Your system',
                icon: 'system',
                permission: 'settings/system',
              },
            ],
          },
          {
            submenu: 'shipmentSettings',
            level: 3,
            title: 'nav_shipping',
            icon: null,
            links: [
              {
                title: 'LBL_PAYERS',
                link: '/settings/shipping/payers',
                description: 'TXT_DESCRIPTION_PAYERS',
                icon: 'team',
                permission: 'settings/payer',
              },
              {
                title: 'Locations',
                link: '/settings/shipping/locations',
                description: 'Your locations',
                icon: 'pin',
                permission: 'settings/sender',
              },
              {
                title: 'Notifications',
                link: '/settings/shipping/notifications',
                description: 'Your notifications',
                icon: 'bell',
                permission: 'settings/message',
              },
              {
                title: 'packaging',
                link: '/settings/shipping/packaging',
                description: 'Your packagings',
                icon: 'savedItems',
                permission: 'settings/package',
              },
              {
                title: 'Agreements',
                link: '/settings/shipping/agreements',
                description: 'Your own agreements',
                icon: 'agreements',
                permission: 'settings/account',
              },
            ],
          },
          {
            submenu: 'integrationSettings',
            level: 3,
            title: 'nav_integration',
            icon: 'network',
            links: [
              {
                title: 'Ftp',
                link: '/settings/integration/ftp',
                description: 'Ftp settings',
                icon: 'server',
                permission: 'settings/ftp',
              },
              {
                title: 'automation',
                link: '/settings/integration/automations',
                description: 'Your automations',
                icon: 'checkAll',
                permission: 'settings/automations',
              },
              {
                title: 'Import templates',
                link: '/settings/integration/import-templates',
                description: 'Your templates',
                icon: 'cloudUpload',
                permission: 'settings/import-template',
              },
              {
                title: 'Webhooks',
                link: '/settings/integration/webhooks',
                description: 'Outgoing webhooks',
                icon: 'network',
                permission: 'settings/webhook',
              },
              // {
              //   title: 'Checkout Engine',
              //   link: '/settings/integration/checkout-engine',
              //   description: 'Carrier field mapping',
              //   icon: 'swapVertical',
              //   permission: 'settings/import-template',
              // },
            ],
          },
        ],
      },
      // 4th group - User settings
      {
        panels: [
          {
            title: 'Settings',
            icon: {
              name: 'single',
              size: 18,
            },
            links: [
              {
                title: 'User Name',
                link: '/profile/preferences',
                description: 'Edit profile',
                icon: 'single',
                permission: true,
              },
              {
                title: 'Logout',
                link: '/logout',
                description: 'See you later',
                icon: 'logout',
                permission: true,
              },
            ],
          },
        ],
      },
    ],
    leftLinks: [
      {
        panels: [
          // Level 1 panel
          {
            title: 'Book',
            link: '/shipments/book-shipment',
            permission: 'shipment/book-shipment',
          }
        ]
      },
      {
        panels: [
          // Level 1 panel
          {
            title: 'Track',
            link: '/shipments/outbound',
            permission: 'shipment/history',
          }
        ]
      },
      {
        panels: [
          // Level 1 panel
          {
            title: 'Pickups',
            link: '/pickups/booked',
            permission: 'pickup/booked',
          }
        ]
      },
      {
        panels: [
          // Level 1 panel
          {
            title: 'EOD',
            link: '/shipments/end-of-day',
            permission: 'shipment/end-of-day',
          }
        ]
      },
      {
        panels: [
          // Level 1 panel
          {
            title: 'Menu',
            level: 1,
            icon: {
              name: 'menu',
              size: 20,
            },
            links: [
              {
                title: 'Dashboard',
                link: '/',
                description: 'Your daily overview',
                icon: 'dashboard',
                permission: 'dashboard',
              },
              {
                title: 'Shipments',
                link: '/shipments',
                description: 'Manage your shipments',
                icon: 'savedItems',
                submenu: 'shipments',
                permission: true,
              },
              {
                title: 'address_book',
                link: '/contacts',
                description: 'All your customers profiles',
                icon: 'contacts',
                permission: 'customer/customer',
              },
              {
                title: 'Settings',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'settings',
                permission: true,
              },
              {
                title: 'Reports',
                link: '/reports',
                description: 'Get data with reports',
                icon: 'cloudDownload',
                permission: 'report/report',
              },
              {
                title: 'Finance',
                link: '/finance',
                description: 'Manage your finances',
                icon: 'coins',
                submenu: 'finances',
                permission: true
              },
              {
                title: 'item_catalog',
                link: '/items',
                description: 'item_catalog_subtext',
                icon: 'softBag',
                permission: 'items/items',
              },
              {
                title: 'pickups',
                link: '/pickups',
                description: 'pickups_subtext',
                icon: 'truck',
                submenu: 'pickups',
                permission: true,
              },
              // Here object needs to be added at the end of array, cause objects are statically used in vue/src/modules/adminv1/src/components/global/linkMenu/index.vue
            ]
          },
          // Level 2 panel(s)
          {
            submenu: 'shipments',
            level: 2,
            title: 'Shipments',
            icon: null,
            links: [
              {
                title: 'Book shipment',
                link: '/shipments/book-shipment',
                description: 'Compare and book',
                icon: 'calendar',
                permission: 'shipment/book-shipment',
              },
              {
                title: 'Waiting for approval',
                link: '/shipments/unapproved-shipments',
                description: 'View all unapproved',
                icon: 'checkAll',
                permission: 'shipment/unapproved-shipments',
              },
              {
                title: 'drafts',
                link: '/shipments/drafts',
                description: 'Uploaded, failed etc.',
                icon: 'edit',
                permission: 'shipment/draft',
              },
              {
                title: 'outbound_shipments',
                link: '/shipments/outbound',
                description: 'View your shipments',
                icon: 'shipmentsAll',
                permission: 'shipment/history',
              },
              {
                title: 'inbound_shipments',
                link: '/shipments/inbound',
                description: 'View inbound shipments',
                icon: 'shipmentsAll',
                permission: 'shipment/shared',
              },
              {
                title: 'End of Day',
                link: '/shipments/end-of-day',
                description: 'View all your manifest',
                icon: 'endOfDay',
                permission: 'shipment/end-of-day',
              },
              {
                title: 'Consolidations',
                link: '/shipments/consolidations',
                description: 'View all your consolidations',
                icon: 'pallet',
                permission: 'shipment/consolidations',
              },
            ],
          },
          {
            submenu: 'settings',
            level: 2,
            title: 'Settings',
            icon: null,
            links: [
              {
                title: 'platform',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'systemSettings',
                permission: true,
              },
              {
                title: 'Shipping',
                link: '/settings',
                description: 'All your settings',
                icon: 'gear',
                submenu: 'shipmentSettings',
                permission: true,
              },
              {
                title: 'Integration',
                link: '/settings',
                description: 'All your integrations',
                icon: 'network',
                submenu: 'integrationSettings',
                permission: false,
              },
            ],
          },
          {
            submenu: 'finances',
            level: 2,
            title: 'Finances',
            icon: null,
            links: [
              {
                title: 'Invoices',
                link: '/finance/invoices',
                description: 'See your invoices',
                icon: 'document',
                permission: 'finance/invoices',
              },
            ],
          },
          // Level 3 panel(s)
          {
            submenu: 'systemSettings',
            level: 3,
            title: 'platform',
            icon: null,
            links: [
              {
                title: 'Printers',
                link: '/settings/platform/printers',
                description: 'Your printers',
                icon: 'printer',
                permission: 'settings/printer',
              },
              {
                title: 'Team',
                link: '/settings/platform/team',
                description: 'Your team',
                icon: 'team',
                permission: 'settings/team',
              },
              {
                title: 'SMTP',
                link: '/settings/platform/smtp',
                description: 'Your smtp',
                icon: 'server',
                permission: 'settings/smtp',
              },
              {
                title: 'system',
                link: '/settings/platform/system',
                description: 'Your system',
                icon: 'system',
                permission: 'settings/system',
              },
            ],
          },
          {
            submenu: 'shipmentSettings',
            level: 3,
            title: 'nav_shipping',
            icon: null,
            links: [
              {
                title: 'LBL_PAYERS',
                link: '/settings/shipping/payers',
                description: 'TXT_DESCRIPTION_PAYERS',
                icon: 'team',
                permission: 'settings/payer',
              },
              {
                title: 'Locations',
                link: '/settings/shipping/locations',
                description: 'Your locations',
                icon: 'pin',
                permission: 'settings/sender',
              },
              {
                title: 'Notifications',
                link: '/settings/shipping/notifications',
                description: 'Your notifications',
                icon: 'bell',
                permission: 'settings/message',
              },
              {
                title: 'packaging',
                link: '/settings/shipping/packaging',
                description: 'Your packagings',
                icon: 'savedItems',
                permission: 'settings/package',
              },
              {
                title: 'Agreements',
                link: '/settings/shipping/agreements',
                description: 'Your own agreements',
                icon: 'agreements',
                permission: 'settings/account',
              },
            ],
          },
          {
            submenu: 'integrationSettings',
            level: 3,
            title: 'nav_integration',
            icon: null,
            links: [
              {
                title: 'Ftp',
                link: '/settings/integration/ftp',
                description: 'Ftp settings',
                icon: 'server',
                permission: 'settings/ftp',
              },
              {
                title: 'automation',
                link: '/settings/integration/automations',
                description: 'Your automations',
                icon: 'checkAll',
                permission: 'settings/automations',
              },
              {
                title: 'Import templates',
                link: '/settings/integration/import-templates',
                description: 'Your templates',
                icon: 'cloudUpload',
                permission: 'settings/import-template',
              },
              {
                title: 'Webhooks',
                link: '/settings/integration/webhooks',
                description: 'Outgoing webhooks',
                icon: 'network',
                permission: 'settings/webhook',
              },
              // {
              //   title: 'Checkout Engine',
              //   link: '/settings/integration/checkout-engine',
              //   description: 'Carrier field mapping',
              //   icon: 'swapVertical',
              //   permission: 'settings/import-template',
              // },
            ],
          },
          {
            submenu: 'pickups',
            level: 2,
            title: 'pickups',
            icon: null,
            links: [
              {
                title: 'booked_pickup',
                link: '/pickups/booked',
                description: 'booked_pickup_desc',
                icon: 'deliveryTime',
                permission: 'pickup/booked',
              },
              {
                title: 'not_planned_pickup',
                link: '/pickups/not-planned',
                description: 'not_planned_pickup_desc',
                icon: 'pointer',
                permission: 'pickup/not-planned',
              },
            ],
          },
        ],
      },
    ],
  },
  actions,
  mutations,
  getters,
};
